import {
  RADIUS_OPTIONS,
  radiusOption,
  TIME_RANGES,
  timeRange,
  type RadiusId,
  type TimeRangeId,
} from '@talkofthetown/shared';
import { Menu } from './Menu';

interface Props {
  radius: RadiusId;
  range: TimeRangeId;
  /** Phones: "10 km · 24 h" instead of "Within 10 km · Last 24 hours". */
  short: boolean;
  onRadius: (r: RadiusId) => void;
  onRange: (r: TimeRangeId) => void;
}

function ChevronIcon() {
  return (
    <svg viewBox="0 0 10 6" width="10" height="6" aria-hidden="true" focusable="false">
      <path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

const distanceName = (id: RadiusId) => radiusOption(id).label.replace(/^Within /, '');

/** How far and how far back the board looks, e.g. "Within 10 km · Last 24 hours". */
export function ScopeMenu({ radius, range, short, onRadius, onRange }: Props) {
  const r = radiusOption(radius);
  const t = timeRange(range);
  return (
    <Menu
      label={`Distance and time: ${r.label}, last ${t.label}`}
      summary={
        <>
          <span className="scope-menu__text">
            {short ? distanceName(radius) : r.label} · {short ? t.short : `Last ${t.label}`}
          </span>
          <ChevronIcon />
        </>
      }
      className="scope-menu"
      panelClassName="scope-menu__panel"
    >
      <p className="menu__title">Distance</p>
      <div className="scope-menu__options">
        {RADIUS_OPTIONS.map((o) => (
          <button
            key={o.id}
            type="button"
            className="scope-option"
            aria-pressed={o.id === radius}
            onClick={() => onRadius(o.id)}
          >
            {distanceName(o.id)}
          </button>
        ))}
      </div>
      <p className="menu__title">Posted in the last</p>
      <div className="scope-menu__options">
        {TIME_RANGES.map((o) => (
          <button
            key={o.id}
            type="button"
            className="scope-option"
            aria-pressed={o.id === range}
            onClick={() => onRange(o.id)}
          >
            {o.label}
          </button>
        ))}
      </div>
    </Menu>
  );
}
